import { useContext, useEffect, useState } from 'react';
import MapContext from '../Map/MapContext';
import OLTileLayer from 'ol/layer/Tile';

const TileLayer = ({ source, extent, zIndex = 0, opacity = 1 }) => {
    const { map } = useContext(MapContext);
    const [olLayer, setOlLayer] = useState();

    useEffect(() => {
        if (!map) return;

        const tileLayer = new OLTileLayer({
            source,
            extent,
            // zIndex,
        });

        map.addLayer(tileLayer);
        // tileLayer.setZIndex(zIndex);
        setOlLayer(tileLayer);

        return () => {
            if (map) {
                map.removeLayer(tileLayer);
            }
        };
    }, [map, extent, source]);

    useEffect(() => {
        if (olLayer) {
            olLayer.setOpacity(opacity);
        }
    }, [opacity, olLayer]);

    useEffect(() => {
        if (olLayer) {
            olLayer.setZIndex(zIndex);
        }
    }, [opacity, zIndex, olLayer]);
    return null;
};

export default TileLayer;
